export { default } from "./src/download-table";

export type { UniformDownloadTableProps } from "./src/download-table";
